// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55d000ed","453":"d29b3d0d","455":"bd838893","977":"0dba5542"}[chunkId] + ".chunk.js";
};